











































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';

import eventBus from '@/utils/eventBus';
import HTTPStatus from '@/constants/httpStatus';
import InviteMerchantSignupModalsModel from '@/views/Models/InviteMerchantSignupModalsModel.vue';

@Component({
  components: {
    Typography,
    FilledButton
  }
})
export default class ConfirmationDeleteLocation extends Mixins(
  Vue,
  InviteMerchantSignupModalsModel
) {
  @Prop() readonly title!: string;
  @Prop() readonly description!: string;
  @Prop() readonly loading!: boolean;

  onClose() {
    eventBus.$emit('closeModal');
  }

  handleDelete() {
    this.$emit('onConfirm');
  }
}
